import { render, staticRenderFns } from "./InternationalWire.vue?vue&type=template&id=3dc6cef7&scoped=true&"
import script from "./InternationalWire.vue?vue&type=script&lang=js&"
export * from "./InternationalWire.vue?vue&type=script&lang=js&"
import style0 from "./InternationalWire.vue?vue&type=style&index=0&id=3dc6cef7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc6cef7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dc6cef7')) {
      api.createRecord('3dc6cef7', component.options)
    } else {
      api.reload('3dc6cef7', component.options)
    }
    module.hot.accept("./InternationalWire.vue?vue&type=template&id=3dc6cef7&scoped=true&", function () {
      api.rerender('3dc6cef7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/forms/InternationalWire.vue"
export default component.exports